import { CALL_PRIVATE_API } from 'js/middleware/api';
import { POST, PUT } from 'js/constants/requestMethods';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const CHECK_PASSWORD_REQUEST = 'CHECK_PASSWORD_REQUEST';
export const CHECK_PASSWORD_SUCCESS = 'CHECK_PASSWORD_SUCCESS';
export const CHECK_PASSWORD_FAILURE = 'CHECK_PASSWORD_FAILURE';

export const changePassword =
  ({ password, password_confirmation, userId }) =>
  (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE],
        endpoint: `/users/${userId}/change_password`,
        requestMethod: PUT,
        payload: {
          password,
          password_confirmation,
        },
      },
    });
  };

export const checkPasswordStrength = (password) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [CHECK_PASSWORD_REQUEST, CHECK_PASSWORD_SUCCESS, CHECK_PASSWORD_FAILURE],
      endpoint: `/password_entropy`,
      requestMethod: POST,
      payload: {
        password,
      },
    },
  });
};
